import React from 'react';
import { EmailCaptureForm } from '../../components/EmailCaptureForm';
import './LandingPage.css';
import { BsShieldCheck, BsEyeSlash, BsEmojiSmile } from 'react-icons/bs';

export default function AnxietyLandingPage() {
  return (
    <div className="landing-page">
      <div className="landing-hero" data-fast-scroll="anxiety_hero_view">
        <img src="/images/GymBuddy.png" alt="GymBuddy" className="landing-logo" onError={(e) => { (e.currentTarget as HTMLImageElement).src = '/images/PokerBuddy.png'; }} />
        <h1 className="landing-title">You Belong in the Gym</h1>
        <p className="landing-subtitle">
          We know walking into the gym can feel overwhelming. That's why we're here—to give you the confidence and support you need to take that first step, and every step after.
        </p>
        
        {/* Hero Image - Part of CTA */}
        <div className="hero-image-container">
          <img src="/images/Anxiety.png" alt="Conquer Gym Anxiety" className="hero-image" />
        </div>

        <EmailCaptureForm campaign="anxiety" placeholder="Enter your email" />
      </div>

      <div className="landing-content" data-fast-scroll="anxiety_benefits_view" data-fast-scroll-threshold="0.5">
        <div className="benefit-grid">
          <div className="benefit-card">
            <div className="benefit-title">
              <BsEyeSlash style={{ color: '#213e70' }} />
              <span>No More Feeling Lost</span>
            </div>
            <p className="benefit-desc">
              You don't need to figure it all out on your own. We'll show you exactly what to do, step-by-step, so you can focus on feeling strong—not stressed.
            </p>
          </div>

          <div className="benefit-card">
            <div className="benefit-title">
              <BsShieldCheck style={{ color: '#213e70' }} />
              <span>Walk In With a Plan</span>
            </div>
            <p className="benefit-desc">
              No more wandering around wondering what's next. We'll build a personalized routine just for you, so every visit feels purposeful and empowering.
            </p>
          </div>

          <div className="benefit-card">
            <div className="benefit-title">
              <BsEmojiSmile style={{ color: '#213e70' }} />
              <span>You're Not Alone</span>
            </div>
            <p className="benefit-desc">
              Thousands of people just like you are starting their fitness journey. Track your progress privately, celebrate your wins, and move at your own pace—no judgment, ever.
            </p>
          </div>
        </div>

        <div className="app-preview-section" data-fast-scroll="anxiety_preview_view">
          <h2 className="app-preview-title">Here's How We Help</h2>
          <div className="app-preview-grid">
            <img src="/images/image.png" alt="App Preview 1" className="app-preview-image" />
            <img src="/images/image1.png" alt="App Preview 2" className="app-preview-image" />
            <img src="/images/image3.png" alt="App Preview 3" className="app-preview-image" />
            <img src="/images/image4.png" alt="App Preview 4" className="app-preview-image" />
          </div>
        </div>
      </div>

      <footer className="landing-footer" data-fast-scroll="anxiety_footer_view">
        © {new Date().getFullYear()} GymBuddy. All rights reserved.
      </footer>
    </div>
  );
}
